import styled from 'styled-components';

export const Header = styled.div`
  padding: 25px 20px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #061e2d;

  display: flex;
  align-items: center;
  gap: 8px;
`;
